import { render } from "./SuppliersGroupIndex.vue?vue&type=template&id=6398f023&scoped=true"
import script from "./SuppliersGroupIndex.vue?vue&type=script&lang=js"
export * from "./SuppliersGroupIndex.vue?vue&type=script&lang=js"

import "./SuppliersGroupIndex.vue?vue&type=style&index=0&id=6398f023&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6398f023"]])

export default __exports__